import { componentName, LoaderLinearClass } from './LoaderLinearClass';

customElements.define(componentName, LoaderLinearClass);

export { LoaderLinearClass, componentName };
